module.exports = __webpack_public_path__ + "static/media/ui-set-up-event.da858dec.png";